exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-picker-panel__footer>.el-button--text{\r\n  display: none;\n}\r\n", ""]);

// exports
